var $ = require('js/sw-jquery/sw-jquery');

//scrolls subnav to top after expanding

module.exports = function ($fragment) {
  $fragment.swFindWithSelf('[data-sw-dms-nav-mob-v2]').each(function () {
    var $el = $(this);

    $el.on('expanded', function () {
      $el.scrollTop(0);
    });
  });
};
